import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { trimEmailValidator } from 'src/app/core/utils/utilities';
import { AuthService } from 'src/app/services/AuthService/auth.service';
import { SharedService } from 'src/app/services/SharedService/shared.service';
import { SwalAlertService } from 'src/app/services/SwalAlertService/swalAlert.service';
import { BRAND } from 'src/app/core/constants/brand';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  readonly brand = BRAND;
  private subscription$ = new Subscription();
  loginForm = this.initializeLoginForm();
  activeRoute: string = '';
  isLoading: boolean = false;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private cd: ChangeDetectorRef,
    private authService: AuthService,
    private sharedService: SharedService,
    public swalAlert: SwalAlertService
  ) {}

  ngOnInit(): void {
    localStorage.clear();
  }

  ngOnDestroy(): void {
    this.subscription$.unsubscribe();
  }

  private initializeLoginForm() {
    return this.fb.group({
      TX_MAIL_FUNC: [
        '',
        {
          nonNullable: true,
          validators: [Validators.required, trimEmailValidator],
        },
      ],
      TX_SENH_FUNC: [
        '',
        { nonNullable: true, validators: [Validators.required] },
      ],
    });
  }

  onSubmit() {
    if (this.loginForm.valid) {
      const { TX_MAIL_FUNC, TX_SENH_FUNC } = this.loginForm.value;
      this.isLoading = true;
      if (
        typeof TX_MAIL_FUNC === 'string' &&
        typeof TX_SENH_FUNC === 'string'
      ) {
        this.subscription$.add(
          this.authService.loginFunc(TX_MAIL_FUNC, TX_SENH_FUNC).subscribe({
            next: () => {
              if (this.authService.isTokenValid) {
                this.router.navigate(['/home']);
                this.isLoading = false;
                return;
              }

              this.isLoading = false;
              this.swalAlert.showAlert(
                'Erro!',
                'Login realizado, mas o token retornado é inválido. Tente novamente.',
                'warning'
              );
            },
            error: (error) => {
              this.isLoading = false;
              this.swalAlert.showAlert(
                'Erro!',
                this.getLoginErrorMessage(error),
                'warning'
              );
            },
            complete: () => {
              this.isLoading = false;
            },
          })
        );
      } else {
        this.swalAlert.showAlert(
          'Erro!',
          'Credenciais inválidas, verifique o email e/ou senha e tente novamente.',
          'warning'
        );
        this.isLoading = false;
      }
    }
  }

  private getLoginErrorMessage(error: any): string {
    const apiError =
      error?.error?.Errors?.Error ??
      error?.error?.Error ??
      (Array.isArray(error?.error?.Errors)
        ? error.error.Errors[0]
        : undefined);

    if (typeof apiError === 'string' && apiError.trim().length > 0) {
      return apiError;
    }

    if (error?.status === 0) {
      return 'Não foi possível conectar à API. Verifique se o backend está rodando em http://localhost:5200.';
    }

    return 'Credenciais inválidas, verifique o email e/ou senha e tente novamente.';
  }

  goTo(route: string) {
    this.sharedService.setIsEmpresa(false);
    this.router.navigate([route]);
    setTimeout(() => {
      this.activeRoute = this.router.url;
      this.cd.detectChanges();
    }, 200);
  }
}
